import { RawMaterialNutrientDto, SampleNutrientDto } from "@sharedcommon/rest/data.restservice";
import { FunctionUtils } from "@sharedcommon/util/functions.util";
import { AnalysisOriginDto } from "./sample/analysis-origin.model";

/**
 * Class to be able to store the table data stored and show in the value component
 */
export class RawMaterialOrSampleNutrientValueTableData {
    code: string;

    value: number|string;
    proposed: number;
    required: boolean ;
    facultative: boolean ;

    /* Standard value from the RawMaterialNutrientDto where it comes from */
    standardFromRawMatNutDto: number;
    /* At true if at the next merge we need to erase the internal results */
    eraseAttributes: boolean;
    
    filled = false;
    selected = false;

    analysisOrigin: AnalysisOriginDto;

    constructor(produNut: RawMaterialNutrientDto|SampleNutrientDto) {
        this.code = produNut.nutrientCode;
        this.analysisOrigin = (produNut as SampleNutrientDto)?.analysisOrigin || null;
    }

    /**
     * Check if the value has to take the standard value considering that this.selected is at true
     * 
     * @returns at true if the selected is for standard value
     */
    isSelectionForStandardValue(): boolean {
        return FunctionUtils.isNotDefined(this.proposed) ;
    }

    /**
     * Return the value considering that this.selected is at true
     * 
     * @returns the corresponding value
     */
    getNeededValueWhenSelected(): number {
        return this.isSelectionForStandardValue() ? this.standardFromRawMatNutDto : this.proposed ;
    }

    /**
     * Check if for this.value can be updated with the standard or the proposed value 
     * 
     * @returns true if this.value can be updated with the standard or the proposed value
     */
    canApplyStandardOrProposedValue(): boolean {
        return !this.facultative && (!this.isSelectionForStandardValue() || (!this.required && (FunctionUtils.isNotDefinedOrEmptyString(this.value) || !this.filled)) ) ;
    }

    /**
     * Return if the table data if for standard, proposed other value
     * 
     * @returns the corresponding type of values
     */
    returnTableSelection(): ProductTableSelection {
        if (this.selected) {
            return this.isSelectionForStandardValue() ? ProductTableSelection.STD : ProductTableSelection.PROPOSED;
        } else {
            return ProductTableSelection.OTHER;
        }
    }
}

/**
 * Enum which indicated for what the table is.
 */
export enum ProductTableSelection {
    STD, PROPOSED, OTHER
}
